import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';

import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { FC, useState } from 'react';
import gtm from '@/utils/gtm';

interface NavProps {
    theme?: 'black' | 'white';
}

const Nav: FC<NavProps> = (props) => {
    const { theme = 'black' } = props;
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = useRouter();

    const { t } = useLang('oceanevcharger');

    const dataA: EcoNavProductProps = {
        tabItems: [
            // {
            //     value: '/ocean-ev-charger',
            //     label: t(`nav_support`),
            //     href: `/${locale}/ocean-ev-charger`,
            // },
            {
                value: '/ocean-ev-charger',
                label: t(`nav_product`),
                href: `/${locale}/ocean-ev-charger`,
            },
            {
                value: '/ocean-ev-charger/support',
                label: t(`nav_support`),
                href: `/${locale}/ocean-ev-charger/support`,
            },
            {
                value: '/ocean-ev-charger/specs',
                label: t(`nav_specs`),
                href: `/${locale}/ocean-ev-charger/specs`,
            },
        ],
        buyItems: [
            {
                value: 'Button',
                label: t(`nav_schedule`),
                href: `/${locale}/ocean-pro-consultation`,
            },
        ],
    };
    const handleBuyChange = (item: any, index: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: item.label,
            product_name: 'EcoFlow OCEAN EV Charger',
        });
    };
    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'logo',
                        label: t(`nav_logo_text`),
                        href: `/${locale}/ocean-ev-charger`,
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={router?.pathname || ''}
                theme={theme}
                onBuyChange={handleBuyChange}
            />
        </div>
    );
};

export default Nav;